/* global $, data, baltData, queryString */
import './venue/index'
import filter from 'lodash/filter'
import Table from 'bam-node-savant-table/table'
import { getSecondaryHeaders, getHeaders } from './venue/table-headers'

const {
    appSettings,
} = require('bam-node-baseball-savant/leaderboard/appSettings')
const {
    CURRENT_VS_WALLTIMORE,
    WALLTIMORE_VS_ORIGINAL,
} = require('bam-node-baseball-savant/constants/walltimore-versions')

let currBaltVersion = Number(queryString.version) || 0

function loadTables() {
    if (data && data.wowy_venue_h) {
        // Parse out N_ values and remove index_ from metric names for column values
        const venueData = filter(
            data.wowy_venue_h,
            (d) =>
                d.metric_key.indexOf('N_') === -1 &&
                Number(d.key_is_year_rolling) ===
                    Number($('#ddlRolling').val()) &&
                d.grouping_venue_conditions === $('#ddlCondition').val() &&
                d.key_bat_side === $('#ddlBatSide').val()
        ).map((d) => {
            d.metric_key = d.metric_key.replace('index_', '').toUpperCase() // eslint-disable-line no-param-reassign
            return d
        })
        // eslint-disable-next-line no-new
        new Table({
            id: 'venue',
            repeatHeader: false,
            // Get Dynamic Headers based on Data
            headers: getHeaders('venue', true, data),
            data: venueData,
            rowClass: 'less-dense-table-row',
            subDataId: 'venue_id',
        })
    }
    if (data && data.wowy_venue_tracked_hip_h) {
        const venueData = filter(data.wowy_venue_tracked_hip_h, (d) => {
            if (
                d.metric_key.indexOf('N_') === -1 &&
                d.key_bat_side === $('#ddlWowyBatSide').val()
            ) {
                if ($('#ddlTrackingCode').val() === 'All') {
                    return (
                        d.key_speed_code === 'All' && d.key_angle_code === 'All'
                    )
                }
                if ($('#ddlTrackingCode').val() === 'Speed') {
                    return (
                        d.key_tracking_code === $('#ddlTrackingCode').val() &&
                        d.key_speed_code === $('#ddlSpeedCode').val()
                    )
                }
                if ($('#ddlTrackingCode').val() === 'Speed x Angle') {
                    return (
                        d.key_tracking_code === $('#ddlTrackingCode').val() &&
                        d.key_speed_code === $('#ddlSpeedCode').val() &&
                        d.key_angle_code === $('#ddlAngleCode').val()
                    )
                }
                if ($('#ddlTrackingCode').val() === 'Angle') {
                    return (
                        d.key_tracking_code === $('#ddlTrackingCode').val() &&
                        d.key_angle_code === $('#ddlAngleCode').val()
                    )
                }
            }
            return false
        }).map((d) => {
            d.metric_key = d.metric_key.replace('index_', '').toUpperCase() // eslint-disable-line no-param-reassign
            return d
        })

        if (venueData.length > 0) {
            $('#wowyVenue').show()

            // eslint-disable-next-line no-new
            new Table({
                id: 'venue_wowy',
                repeatHeader: false,
                headers: getHeaders('wowy_venue_tracked_hip_h', true, data),
                data: venueData,
                rowClass: 'less-dense-table-row',
                subDataId: 'venue_id',
            })
        }
    }
    if (data && data.venue_distance_h) {
        const venueData = data.venue_distance_h

        if (venueData.length > 0) {
            // eslint-disable-next-line no-new
            new Table({
                id: 'distance',
                secondaryHeaders: getSecondaryHeaders('distance-venue'),
                repeatHeader: false,
                headers: getHeaders('distance-all', false, data).map((d) => ({
                    ...d,
                    sortable: false,
                })),
                data: venueData,
                rowClass: 'less-dense-table-row',
                subDataId: 'venue_id',
            })
        }
    }
    if (data && data.venues) {
        data.venues.map((d) => ({
            ...d,
            year_opened: Number(d.year_opened),
            left_line: Number(d.left_line),
            left_center: Number(d.left_center),
            center: Number(d.center),
            right_center: Number(d.right_center),
            right_line: Number(d.right_line),
        }))

        // eslint-disable-next-line no-new
        new Table({
            id: 'venue_meta',
            repeatHeader: false,
            secondaryHeaders: [
                {
                    name: '',
                    colspan: 6,
                    headerClass: 'th-name-header align-center',
                },
                {
                    name: 'Fence Distance from Plate (feet)',
                    colspan: 5,
                    headerClass: 'th-title-header align-center',
                },
            ],
            headers: getHeaders('meta', false, data),
            data: data.venues,
            rowClass: 'less-dense-table-row',
            subDataId: 'venue_id',
        })
    }
    if (baltData.yearly.length > 0) {
        // eslint-disable-next-line no-new
        new Table({
            id: 'bal_batter_pitcher_yearly_totals',
            repeatHeader: false,
            headers: getHeaders(
                'bal_batter_pitcher_yearly_totals',
                false,
                data
            ),
            data: baltData.yearly,
        })
    }
    if (baltData.allPlays.length > 0) {
        // eslint-disable-next-line no-new
        new Table({
            id: 'bal_homeruns_lost_events',
            repeatHeader: false,
            headers: getHeaders('bal_homeruns_lost_events', false, data),
            data: baltData.allPlays,
        })
    }
    if (baltData.batters.length > 0) {
        // eslint-disable-next-line no-new
        new Table({
            id: 'bal_batter_hrs_lost',
            repeatHeader: false,
            headers: getHeaders('bal_batter_hrs', false, data),
            secondaryHeaders: [
                {
                    name: `Hitters with most HR ${
                        Number(queryString.version) === CURRENT_VS_WALLTIMORE
                            ? 'gained'
                            : 'lost'
                    }`,
                    colspan: 2,
                    headerClass: 'th-name-header align-center',
                },
            ],
            data: baltData.batters,
        })
    }
    if (baltData.pitchers.length > 0) {
        // eslint-disable-next-line no-new
        new Table({
            id: 'bal_pitcher_hrs_saved',
            repeatHeader: false,
            headers: getHeaders('bal_pitcher_hrs', false, data),
            secondaryHeaders: [
                {
                    name: `Pitchers with most HR ${
                        Number(queryString.version) === CURRENT_VS_WALLTIMORE
                            ? 'added'
                            : 'saved'
                    }`,
                    colspan: 2,
                    headerClass: 'th-name-header align-center',
                },
            ],
            data: baltData.pitchers,
        })
    }
}
loadTables()

$('#batter-hrs-lost-expander').click(() => {
    $('#bal_batter_hrs_lost').toggleClass('collapsed')
    if ($('#bal_batter_hrs_lost').hasClass('collapsed')) {
        $('#batter-hrs-lost-expander-text').html('Show All')
    } else {
        $('#batter-hrs-lost-expander-text').html('Show Fewer')
    }
})

$('#pitcher-hrs-saved-expander').click(() => {
    $('#bal_pitcher_hrs_saved').toggleClass('collapsed')
    if ($('#bal_pitcher_hrs_saved').hasClass('collapsed')) {
        $('#pitcher-hrs-saved-expander-text').html('Show All')
    } else {
        $('#pitcher-hrs-saved-expander-text').html('Show Fewer')
    }
})

$('#bal-homeruns-lost-events-expander').click(() => {
    $('#bal_homeruns_lost_events').toggleClass('collapsed')
    if ($('#bal_homeruns_lost_events').hasClass('collapsed')) {
        $('#bal-homeruns-lost-events-expander-text').html('Show All')
    } else {
        $('#bal-homeruns-lost-events-expander-text').html('Show Fewer')
    }
})

$('.form-control').change(() => {
    loadTables()

    $('#lblCondition').html(
        `Condition: ${$('#ddlCondition option:selected').text()}`
    )
    $('#lblRolling').html(
        `Is 3 Year Rolling: ${$('#ddlRolling option:selected').text()}`
    )
    $('#lblBatSide').html(
        `Bat Side: ${$('#ddlBatSide option:selected').text()}`
    )

    $('#lblTrackingCode').html(
        `Tracking: ${$('#ddlTrackingCode option:selected').text()}`
    )

    if (
        $('#ddlTrackingCode').val() === 'Speed' ||
        $('#ddlTrackingCode').val() === 'Speed x Angle'
    ) {
        $('#speed-container').show()
    } else {
        $('#speed-container').hide()
    }

    $('#lblSpeedCode').html(
        `Speed: ${$('#ddlSpeedCode option:selected').text()}`
    )

    if (
        $('#ddlTrackingCode').val() === 'Angle' ||
        $('#ddlTrackingCode').val() === 'Speed x Angle'
    ) {
        $('#angle-container').show()
    } else {
        $('#angle-container').hide()
    }

    $('#lblAngleCode').html(
        `Angle: ${$('#ddlAngleCode option:selected').text()}`
    )
    $('#lblWowyBatSide').html(
        `Bat Side: ${$('#ddlWowyBatSide option:selected').text()}`
    )
    updateUrl()
})

function updateUrl() {
    const url = `/leaderboard/statcast-venue?venueId=${$(
        '#ddlVenueSelect'
    ).val()}&condition=${$('#ddlCondition').val()}&rolling=${$(
        '#ddlRolling'
    ).val()}&batSide=${$('#ddlBatSide').val()}&tracking=${$(
        '#ddlTrackingCode'
    ).val()}&speed=${$('#ddlSpeedCode').val()}&angle=${$(
        '#ddlAngleCode'
    ).val()}&wowyBatSide=${$('#ddlWowyBatSide').val()}`

    window.history.pushState('', '', url)
    return url
}

function loadQueryStringValues() {
    if (queryString) {
        if (queryString.year) {
            $('#ddlSeason').val(queryString.year).attr('selected', true)
            $('#lblSeason').html(
                `Year: ${$('#ddlSeason option:selected').text()}`
            )
        }
        if (queryString.venueId) {
            $('#ddlVenueSelect').val(queryString.venueId).attr('selected', true)
        }
        if (queryString.condition) {
            $('#ddlCondition').val(queryString.condition).attr('selected', true)
            $('#lblCondition').html(
                `Condition: ${$('#ddlCondition option:selected').text()}`
            )
        }
        if (queryString.rolling) {
            $('#ddlRolling').val(queryString.rolling).attr('selected', true)
            $('#lblRolling').html(
                `Is 3 Year Rolling: ${$('#ddlRolling option:selected').text()}`
            )
        }
        if (queryString.batSide) {
            $('#ddlBatSide').val(queryString.batSide).attr('selected', true)
            $('#lblBatSide').html(
                `Bat Side: ${$('#ddlBatSide option:selected').text()}`
            )
        }
        if (queryString.tracking) {
            $('#ddlTrackingCode')
                .val(queryString.tracking)
                .attr('selected', true)
            $('#lblTrackingCode').html(
                `Tracking: ${$('#ddlTrackingCode option:selected').text()}`
            )
        }
        if (queryString.speed) {
            $('#ddlSpeedCode').val(queryString.speed).attr('selected', true)
            $('#lblSpeedCode').html(
                `Speed: ${$('#ddlSpeedCode option:selected').text()}`
            )
        }
        if (queryString.angle) {
            $('#ddlAngleCode').val(queryString.angle).attr('selected', true)
            $('#lblAngleCode').html(
                `Angle: ${$('#ddlAngleCode option:selected').text()}`
            )
        }
        if (queryString.wowyBatSide) {
            $('#ddlWowyBatSide')
                .val(queryString.wowyBatSide)
                .attr('selected', true)
            $('#lblWowyBatSide').html(
                `Bat Side: ${$('#ddlWowyBatSide option:selected').text()}`
            )
        }

        if (
            $('#ddlTrackingCode').val() === 'Speed' ||
            $('#ddlTrackingCode').val() === 'Speed x Angle'
        ) {
            $('#speed-container').show()
        } else {
            $('#speed-container').hide()
        }

        if (
            $('#ddlTrackingCode').val() === 'Angle' ||
            $('#ddlTrackingCode').val() === 'Speed x Angle'
        ) {
            $('#angle-container').show()
        } else {
            $('#angle-container').hide()
        }

        if (
            window.location.hash &&
            document.querySelector(`[href='${window.location.hash}']`)
        ) {
            setTimeout(() => {
                const $el = document.querySelector(
                    `[href='${window.location.hash}']`
                )
                const { top } = $el.getBoundingClientRect()

                if (Math.abs(top) > 50) {
                    window.scroll({
                        top: top + window.scrollY - 20,
                        behavior: 'smooth',
                    })
                }
            }, 1000)
        }
    }
}

$(document).ready(() => {
    loadQueryStringValues()

    if (document.getElementById('btn-update')) {
        document.getElementById('btn-update').addEventListener('click', () => {
            window.location = `${updateUrl()}&year=${$(
                '#ddlSeason'
            ).val()}&version=${$('#ddlVersion').val()}#walltimore`
        })
    }

    $('#ddlVersion').on('change', () => {
        const yearSelector = document.getElementById('ddlSeason')
        const versionSelector = document.getElementById('ddlVersion')
        const selected = Number(
            versionSelector.selectedOptions[0].getAttribute('value')
        )

        if (selected !== currBaltVersion) {
            $('#ddlSeason').empty()

            if (selected === WALLTIMORE_VS_ORIGINAL) {
                appSettings.parkFactors.wallChangeYears.forEach((year) => {
                    const newOption = document.createElement('option')
                    newOption.value = `${year}`
                    newOption.text = year
                    yearSelector.add(newOption)
                })
            } else {
                appSettings.parkFactors.secondWallChangeYears.forEach(
                    (year) => {
                        const newOption = document.createElement('option')
                        newOption.value = `${year}`
                        newOption.text = year
                        yearSelector.add(newOption)
                    }
                )
            }
            currBaltVersion = selected
        }
    })

    $('#ddlVenueSelect').change(() => {
        window.location = `/leaderboard/statcast-venue?venueId=${$(
            '#ddlVenueSelect'
        ).val()}`
    })

    $('#btnParkFactors').click(() => {
        window.location = '/leaderboard/statcast-park-factors'
    })
})
